"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.evaluate = evaluate;
exports.getResolvedFieldDependencies = getResolvedFieldDependencies;
exports.OperandType = exports.Operator = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var Operator;
exports.Operator = Operator;

(function (Operator) {
  Operator["not"] = "not";
  Operator["and"] = "and";
  Operator["or"] = "or";
  Operator["greaterThan"] = "greaterThan";
  Operator["lessThan"] = "lessThan";
  Operator["equalTo"] = "equalTo";
  Operator["resolve"] = "resolve";
  Operator["resolved"] = "resolved";
  Operator["transform"] = "transform";
})(Operator || (exports.Operator = Operator = {}));

var OperandType;
exports.OperandType = OperandType;

(function (OperandType) {
  OperandType["literal"] = "literal";
  OperandType["resolved"] = "resolved";
})(OperandType || (exports.OperandType = OperandType = {}));

function evaluate(r, resolve) {
  var res1;
  var res2;

  switch (r.type) {
    case OperandType.literal:
    case OperandType.resolved:
      res1 = helper(r, resolve);
      return res1;

    case Operator.not:
      res1 = evaluate(r.op1, resolve);
      return !res1;

    case Operator.resolve:
      res1 = evaluate(r.op1, resolve);
      return res1;

    case Operator.and:
      res1 = evaluate(r.op1, resolve);
      res2 = evaluate(r.op2, resolve);
      return res1 && res2;

    case Operator.or:
      res1 = evaluate(r.op1, resolve);
      res2 = evaluate(r.op2, resolve);
      return res1 || res2;

    case Operator.greaterThan:
      res1 = helper(r.op1, resolve);
      res2 = helper(r.op2, resolve);
      return res1 > res2;

    case Operator.lessThan:
      res1 = helper(r.op1, resolve);
      res2 = helper(r.op2, resolve);
      return res1 < res2;

    case Operator.equalTo:
      res1 = helper(r.op1, resolve);
      res2 = helper(r.op2, resolve);
      return res1 === res2;

    case Operator.transform:
      return r.cb(helper(r.op1, resolve));

    default:
      throw new Error("Unknown evaluation type ".concat(r.type));
  }
}

function helper(o, resolve) {
  switch (o.type) {
    case OperandType.literal:
      return o.value;

    case OperandType.resolved:
      return resolve(o);

    default:
      throw new Error("Unknown operand type ".concat(o));
  }
}

function getResolvedFieldDependencies(o) {
  var _context;

  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  switch (o.type) {
    case OperandType.resolved:
      deps.push(o.fieldIdentifier);
      return deps;

    case OperandType.literal:
      return deps;

    case Operator.not:
    case Operator.resolve:
    case Operator.transform:
      return getResolvedFieldDependencies(o.op1, deps);

    case Operator.resolved:
      return deps;

    default:
      return (0, _concat.default)(deps).call(deps, (0, _concat.default)(_context = getResolvedFieldDependencies(o.op1, [])).call(_context, getResolvedFieldDependencies(o.op2, [])));
  }
}
